import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { ConvertService } from 'src/app/services/convert.service';
import { GENDERS, DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ITrainingBatch, ITrainingAdmission } from 'src/app/interfaces/training';
import { TrainingStore } from 'src/app/stores/training/training.store';
import { MappingService, pushToArray, addMonth, addMonthFromDuration, toDateKey } from 'src/app/services/mapping.service';

@Component({
  selector: 'app-add-training-adminssion',
  templateUrl: './add-training-adminssion.component.html',
  styleUrls: ['./add-training-adminssion.component.scss']
})
export class AddTrainingAdminssionComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;

  form: FormGroup;
  batch: AbstractControl;


  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new admission';
  ITEM: ITrainingAdmission;

  LIST: any;

  constructor(
    public dialogRef: MatDialogRef<AddTrainingAdminssionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: TrainingStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }

  async ngOnInit() {
    const { ITEM } = this.data;
    this.ITEM = ITEM || null;
    this.form = this.fb.group({
      batch: [ITEM ? ITEM.batchKey : null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      description: [ITEM ? ITEM.description : null,],
      duration: [null, Validators.required],
      admissionDate: [new Date(), Validators.required],
    })
    this.batch = this.form.controls['batch'];

    const LIST = pushToArray(await this.ds.trainingBatchRef("name").get().toPromise())
    this.LIST = MappingService.autoComplete(this.batch, LIST, "name");

    if (ITEM) {
      this.TITLE = "Edit batch";
      const { batchKey } = ITEM;
      this.form.patchValue({
        batch: LIST.filter(m => m.key === batchKey)[0],
      })
    }
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }


  displayItem(item: any): string {
    return item ? item.name || item.fullName : item;
  }
  displayItemFullName(item: any): string {
    return item ? item.fullName : item;
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      const { ITEM, SELECTED_STUDENT } = this.data;
      const { description, duration, admissionDate } = f;
      const batch: ITrainingBatch = f.batch;
      this.form.disable();
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.error = null;
      this.isCreate = true;
      
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const expiredDate = addMonthFromDuration(admissionDate, duration);
      const item: ITrainingAdmission = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${batch.name}`),
        organizationRef: selectedCompanyKey ? this.ds.companyRef().doc(selectedCompanyKey).ref : null,
        organizationKey: selectedCompanyKey || null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,

        studentKey: SELECTED_STUDENT.key,
        studentRef: this.ds.studentRef().doc(SELECTED_STUDENT.key).ref,
        description,
        admissionDate: admissionDate,
        admissionDateKey: toDateKey(admissionDate),
        expiredDate: expiredDate,
        expiredDateKey: toDateKey(expiredDate),
        duration,
        //ref
        programKey: batch.programKey,
        programRef: batch.programRef,
        levelKey: batch.levelKey,
        levelRef: batch.levelRef,
        tutorKey: batch.tutorKey,
        tutorRef: batch.tutorRef,
        batchKey: batch.key,
        batchRef: this.ds.trainingBatchRef('name').doc(batch.key).ref,
      }
      this.store.addAdmission(item, (success, res) => {
        if (success) {
          this.snackBar.open("Admission has been saved successful.", "Done", { duration: 1000 });
          if (!isNew) {
            this.dialogRef.close('no')
            return;
          }
          this.form.reset();
          this.form.enable();
          this.processNew = false;
          this.processClose = false;
          this.isCreate = false;
          this.inputEl.nativeElement.focus()
        }

      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}